export {default as ExpiringWellnessCredits} from './ExpiringWellnessCredits.connect';
